import styled, { css } from 'styled-components'

import { ReactComponent as RemoveFile } from '../../../../../../../assets/icons/removeIcon.svg'
import { ReactComponent as ChevronDownFile } from '../../../../../../../assets/icons/chevron-down.svg'

export const CustomStyles = {
  option: (provided: any) => ({
    ...provided,
    fontSize: 16,
    '& input': {
      font: 'inherit'
    }
  }),
  multiValue: (styles: any) => {
    return {
      ...styles,
      fontSize: 16
    }
  },
  control: (provided: any) => ({
    ...provided,
    background: '#F4F4F4',
    border: 0,
    boxShadow: 'none',
    padding: '2px 16px',
    borderRadius: '8px'
  }),
  placeholder: (provided: any) => ({
    ...provided,
    fontFamily: 'Poppins',
    fontSize: 16,
    '& input': {
      font: 'inherit'
    }
  }),
  input: (provided: any) => ({
    ...provided,
    fontFamily: 'Poppins',
    fontSize: 16,
    width: 'max-content',
    '& input': {
      font: 'inherit'
    }
  })
}

export const ChevronDownIcon = styled(ChevronDownFile)`
  cursor: pointer;
  fill: #8601c9;
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  transition: 0.3s ease;
  &:hover {
    top: 55%;
  }
`

export const RemoveIcon = styled(RemoveFile)`
  cursor: pointer;
`

export const SelectedSections = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    margin: ${theme.spacing.stack.small} 0 ${theme.spacing.stack.sm};
    > div {
      margin: ${theme.spacing.stack.small} ${theme.spacing.stack.small} 0;
    }
  `}
`

export const SelectedSectionCard = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${theme.spacing.stack.small} ${theme.spacing.inline.xxxs};
    background: #8601c9;
    border-radius: ${theme.border.radius.medium};
    > p {
      color: white;
      margin-right: ${theme.spacing.stack.small};
    }
  `}
`

export const TicketPerSession = styled.div`
  display: flex;
  flex-direction: column;
  .sessionInputs {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    > div {
      margin-right: 2rem;
    }
    @media (max-width: 1170px) {
      width: 100%;
      flex-direction: column;
      > div {
        margin-right: 0;
      }
    }
  }
`

export const TicketTypeSelection = styled.div`
  ${({ theme }) => css`
    display: flex;
    width: max-content;
    flex-direction: column;
    .optionsWrapper {
      margin-top: 2rem;
      display: flex;
      > div:first-of-type {
        margin-right: ${theme.spacing.stack.xl};
      }
    }
    @media (max-width: 1170px) {
      .optionsWrapper {
        flex-direction: column;
      }
    }
  `}
`

export const RadioButtonBox = styled.div`
  ${({ theme }) => css`
    display: flex;
    > p {
      margin-left: ${theme.spacing.stack.small};
    }
    @media (max-width: 1170px) {
      margin-top: ${theme.spacing.stack.small};
    }
  `}
`

export const TicketInfoBox = styled.div`
  ${({ theme }) => css`
    margin: ${theme.spacing.stack.xxs} 0;
    display: flex;
    flex-direction: column;
    @media (min-width: 1170px) {
      width: max-content;
      > div {
        width: max-content;
      }
    }
  `}
`

export const PriceBox = styled.div`
  ${({ theme }) => css`
    display: flex;
    > div:first-child {
      margin-right: ${theme.spacing.inline.xxs};
    }
    .input {
      width: max-content;
    }

    @media (max-width: 1170px) {
      flex-direction: column;
      > div {
        width: 100%;
      }
      .input {
        width: 100%;
      }
    }
  `}
`

export const CategoriesSection = styled.section`
  ${({ theme }) => css`
    margin-top: ${theme.spacing.stack.xxs};
    .categories {
      padding: ${theme.spacing.stack.xxxs};
      border-radius: ${theme.border.radius.medium};
      background-color: #f4f4f4;
      margin-top: ${theme.spacing.stack.xxxs};
      margin-bottom: ${theme.spacing.stack.small};
    }
  `}
`

export const CategorieCard = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacing.stack.xxxs};
    box-shadow: 0px 4px 11px rgba(0, 0, 0, 0.25);
    margin-bottom: ${theme.spacing.stack.small};
    border-radius: ${theme.border.radius.medium};
    position: relative;
  `}
`
